<div class="wrapper">
  <div class="w-100 d-flex">
    <div class="category-news__wrapper col-xxl-9 col-lg-8 col-9">
      <div class="category-news">
        <div
          class="category-news-header regular-container d-flex align-items-center"
        >
          <h1 class="category-news-title">
            {{ categoryInfo?.title }}
          </h1>
          <div class="category-news-controls ml-auto desktop-screen">
            <div
              class="category-news-control"
              (click)="changeGrid(false)"
              [class.active]="!gridView"
            >
              <i class="fa fa-bars"></i>
            </div>
            <div
              class="category-news-control"
              (click)="changeGrid(true)"
              [class.active]="gridView"
            >
              <i class="fa fa-th"></i>
            </div>
          </div>
        </div>
        <app-loader *ngIf="loading" position="top"></app-loader>

        <ng-container *ngIf="newsData">
          <app-main-news-pagination
            *ngIf="newsData.data && newsData.data.length"
            [gridView]="gridView"
            [newsData]="newsData"
            (pageChanged)="pageChanged($event)"
            [urlPagination]="true"
          >
          </app-main-news-pagination>
        </ng-container>

        <div
          class="text-center"
          *ngIf="(!newsData || (newsData && !newsData.data.length)) && !loading"
          i18n
        >
          ჩანაწერები ვერ მოიძებნა
        </div>
      </div>
    </div>
    <div class="desktop-screen col-xxl-3 col-lg-4 col-3">
      <app-sidebar></app-sidebar>
    </div>
  </div>
</div>
